import { Box, Drawer, DrawerContent, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// import AddDirectorBanner from '../../modules/Dashboard/AddDirectors/AddDirectorBanner';s
import TwoFactorSetupBanner from '../../modules/Settings/Security/TwoFactorAuth/TwoFactorSetupBanner';
import TwoFactorSetupPromptModal from '../../modules/Settings/Security/TwoFactorAuth/TwoFactorSetupPromptModal';
import { useTwoFactorSetupPrompt } from '../../modules/Settings/Security/TwoFactorAuth/useTwoFactorSetupPrompt';
import AppHeader from './AppHeader';
import { AppLayoutProvider } from './AppLayoutContext';
import AppSidebar, { DRAWER_WIDTH } from './AppSidebar';
import LayoutNotificationBanners from './LayoutNotificationBanners';

const APP_HEADER_HEIGHT = 80;

export default function AppLayout() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();
  const {
    isModalOpen,
    showBanner,
    layoutOffset,
    dismissPrompt,
    handleSetupNow,
  } = useTwoFactorSetupPrompt();

  useEffect(() => {
    setTimeout(() => {
      onClose(); // Close the mobile sidebar drawer on route change
    }, 300);
  }, [location, onClose]);

  return (
    <AppLayoutProvider value={{ layoutOffset }}>
      <Box bg="#fafafa" minHeight="100%" overflow="hidden">
        {showBanner && (
          <Box position="fixed" top={0} left={0} right={0} zIndex={1002}>
            <TwoFactorSetupBanner onSetupNow={handleSetupNow} />
          </Box>
        )}

        <TwoFactorSetupPromptModal
          isOpen={isModalOpen}
          onClose={dismissPrompt}
          onSetupNow={handleSetupNow}
          onSetupLater={dismissPrompt}
        />

        <Box>
          <AppHeader onOpen={onOpen} top={layoutOffset} />
          <AppSidebar
            top={`${layoutOffset}px`}
            h={layoutOffset ? `calc(100vh - ${layoutOffset}px)` : '100vh'}
            onClose={() => onClose}
            display={{ base: 'none', md: 'block' }}
          />
          <Drawer
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <AppSidebar onClose={onClose} />
            </DrawerContent>
          </Drawer>
        </Box>

        <Box
          as="main"
          ml={{ base: 0, md: DRAWER_WIDTH }}
          p={{ base: 4, md: '44px' }}
          pb="5rem"
          flexGrow={1}
          background="white"
          border="1px solid #ebedef"
          borderRadius={{ base: 0, md: '24px 0px 0px 24px' }}
          mt={`${APP_HEADER_HEIGHT + layoutOffset}px`}
          mb={{ base: 0, md: 6 }}
          overflow="auto"
          minH={
            layoutOffset
              ? `calc(100vh - ${APP_HEADER_HEIGHT + layoutOffset}px - 24px)`
              : '90vh'
          }
        >
          <Box maxW="1728px" margin="auto">
            <LayoutNotificationBanners />
            {/* <AddDirectorBanner /> */}
            <Outlet />
          </Box>
        </Box>
      </Box>
    </AppLayoutProvider>
  );
}
